import {
  Component,
  inject,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {AsyncPipe} from '@angular/common';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';
import {AppState} from '../../store/store';
import {HeaderComponent} from '../../components/header/header.component';
import {LoginFormComponent} from '../../components/login-form/login-form.component';
import {FooterContactComponent} from '../../components/footer-contact/footer-contact.component';
import {FooterInfoComponent} from '../../components/footer-info/footer-info.component';
import {
  selectCommunicationContact,
  selectCommunicationWay,
  selectLoginPageText,
} from '../../store/contact/contact.selectors';
import {HtmlContentComponent} from '../../components/html-content/html-content.component';
import {PageTitleComponent} from '../../components/page-title/page-title.component';

@Component({
  selector: 'app-login',
  imports: [
    HeaderComponent,
    LoginFormComponent,
    FooterContactComponent,
    FooterInfoComponent,
    HtmlContentComponent,
    TranslatePipe,
    PageTitleComponent,
    AsyncPipe,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  private route: ActivatedRoute = inject(ActivatedRoute);

  public username = toSignal(
    this.route.params.pipe(map(params => params?.['username'] ?? '')),
    {initialValue: ''},
  );

  public communicationWay$ = this.store.select(selectCommunicationWay);

  public communicationContact$ = this.store.select(selectCommunicationContact);

  public loginPageText$ = this.store.select(selectLoginPageText);

}
